import { History } from 'history';
import type { MouseEvent } from 'react';

export interface TransactionDetailsLinkOptions {
	highlightAuth?: number;
	highlightEticket?: string;
}

export const buildTransactionDetailsPath = (transactionId: number, options?: TransactionDetailsLinkOptions): string => {
	const params = new URLSearchParams();
	if (options?.highlightAuth != null) {
		params.set('highlightAuth', String(options.highlightAuth));
	}
	if (options?.highlightEticket) {
		params.set('highlightEticket', options.highlightEticket);
	}
	const query = params.toString();
	return `/transaction-details/${transactionId}${query ? `?${query}` : ''}`;
};

export const openTransactionDetails = (
	history: History,
	transactionId: number,
	options?: TransactionDetailsLinkOptions,
	event?: MouseEvent,
): void => {
	const path = buildTransactionDetailsPath(transactionId, options);
	if (event?.ctrlKey || event?.metaKey) {
		event.preventDefault();
		window.open(path, '_blank', 'noopener,noreferrer');
		return;
	}
	history.push(path);
};

export const LIST_ROW_NAV_HINT =
	'Doble clic para abrir. Ctrl + clic (⌘ + clic en Mac) para abrir en una nueva pestaña.';
